import { styled, withTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Span, Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';

const TileButtonTextSpan = styled(Span)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
  user-select: none;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  white-space: initial;
  word-break: break-word;
`;

const _excluded = ["isDisabled", "theme"];
const TileButtonDiv = styled(Div).attrs(_ref => {
  let {
      isDisabled,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    hoverBorderColor: !isDisabled ? theme.palette.action.hoverBorder : 'none',
    hoverBoxShadow: !isDisabled ? theme.shadows[2] : 'none',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.button.fontWeight,
    letterSpacing: theme.typography.button.letterSpacing,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
    p: theme.spacing.sm,
    opacity: isDisabled ? 0.4 : 1,
    pointerEvents: isDisabled ? 'none' : 'all'
  }, props);
})`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: inherit;
  border-radius: 2px;
  user-select: none;
  text-align: center;
  text-decoration: none;
  transition: box-shadow 0.2s, background-color 0.2s, border-color 0.2s;

  &:active,
  &:focus,
  &:hover {
    border-color: ${({
  hoverBorderColor
}) => hoverBorderColor};
    box-shadow: ${({
  hoverBoxShadow
}) => hoverBoxShadow};
  }
`;

const TileButtonBannerDiv = styled(Div)`
  width: 0;
  height: 0;
  border-left: 70px solid transparent;
  border-right: 70px solid #7d8182;
  border-bottom: 70px solid transparent;
  position: absolute;
  right: 0px;
  z-index: 2;
  top: 0;
`;

const TileButtonBannerTextDiv = styled(Div)`
  width: 100%;
  transform: rotateZ(45deg);
  position: absolute;
  left: 25px;
`;

const TileButton = ({
  icon,
  title,
  onClick,
  styles = {},
  isDisabled = false,
  theme,
  bannerText = '',
  showBanner = false
}) => {
  return /*#__PURE__*/createElement(TileButtonDiv, _extends({
    testId: "tile-button",
    onClick: onClick,
    isDisabled: isDisabled
  }, styles.root), showBanner && /*#__PURE__*/createElement(TileButtonBannerDiv, null, /*#__PURE__*/createElement(TileButtonBannerTextDiv, null, bannerText)), /*#__PURE__*/createElement(Icon, _extends({
    styles: {
      root: {
        mb: theme.spacing.sm
      }
    }
  }, icon)), /*#__PURE__*/createElement(TileButtonTextSpan, null, title));
};
var TileButton$1 = withTheme(TileButton);

export default TileButton$1;
